<template>
    <div
            @click="selectItem"
            v-bind:class="{current: isCurrent}"
            :key="item.model.id"
    >
        <div class="flex-grow-1 contact">
            <span class="filemaker-id" v-if="filemakerId">{{ filemakerId }} </span>
            <span class="contact-full-name">{{ fullName | uppercase }}</span>
            <span class="contact-phone-number" v-if="phoneNumber">({{ phoneNumber }})</span>
        </div>
        <div>
            <el-tooltip content="Edit" placement="top-start">
                <span class="btn btn-link btn-link-purple btn-sm" @click.stop="edit"><i class="fas fa-edit"></i></span>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      isCurrent: Boolean,
      item: Object,
      select: Function,
    },

    computed: {
      /**
       * @return {string}
       */
      filemakerId() {
        return _.get(this.item, 'model.filemaker_id');
      },

      /**
       * @return {string}
       */
      fullName() {
        return _.get(this.item, 'model.full_name');
      },

      /**
       * @return {string}
       */
      phoneNumber() {
        return _.get(this.item, 'model.phone_number');
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      selectItem() {
        this.select(this.item);
      },

      /**
       * @event edit
       */
      edit() {
        this.$emit('edit', {url: this.item.editUrl});
      },
    },
  }
</script>
